import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HyperlinkProvider } from "./contexts/HyperlinkProvider";

const location = window.location.pathname.toLowerCase();
const baseName = process.env.REACT_APP_BASENAME;
const root = ReactDOM.createRoot(document.getElementById("root"));

let basePath = baseName;
if (baseName === "/april2024") {
  basePath = basePath + "/";
}

root.render(
  <React.StrictMode>
    <HyperlinkProvider>
      <BrowserRouter>
        {location === baseName || location === "/april2024/" ? <App /> : ""}
        {location !== baseName && location !== "/april2024/" ? <App /> : ""}
      </BrowserRouter>
    </HyperlinkProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
